import { createFileRoute } from '@tanstack/react-router';
import { UsersTab } from '../../../features/B1/users-tab';

export const Route = createFileRoute('/_app/settings/users')({
  component: UsersTab,
});
